import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import ILandingDomain from "@/interfaces/ILandingDomain";
import ILandingRegion from "@/interfaces/ILandingRegion";
import ITableCol from "@/interfaces/ITableCol";
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import cleanData from "@/libs/cleanData";
import transformDateFields from "@/libs/date/transformDateFields";
import getParamQuery from "@/libs/getParamQuery";
import getQueryData from "@/libs/getQueryData";
import getTableColumns from "@/libs/getTableColumns";
import isEmpty from "@/libs/isEmpty";
import {transformMultiSelect} from "@/libs/transformData/transformMultiSelect";
import Multiselect from 'vue-multiselect';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import Loader from '@/components/Includes/Loader/Loader.vue';
import IPayloadQuery from '@/interfaces/IPayloadQuery';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import {Switch as cSwitch} from '@coreui/vue';

import {addDays, format} from 'date-fns';

const today = new Date();


import LandingDomainCreate from '@/components/LandingDomains/LandingDomainCreate/LandingDomainCreate.vue';
import LandingDomainDetail from '@/components/LandingDomains/LandingDomainDetail/LandingDomainDetail.vue';

@Component({
    name: 'LandingDomainsList',
    components: {
        Loader,
        LandingDomainCreate,
        LandingDomainDetail,
        TableEmpty,
        Multiselect,
        CardHeader,
        cSwitch
    }
})
export default class LandingDomainsList extends Vue {

    // Begin Vuex Logic for Landing Region
    @Action private landingRegionsList!: (query: IPayloadQuery) => Promise<void>;
    @Getter private getLandingRegions!: () => ILandingRegion[];
    // End Vuex Logic for Landing Region

    // Begin Vuex Logic for Landing Domain
    @Action private landingDomainRemove!: (id: number) => string;
    @Action private landingDomainExpiresAt!: (payload: { id: number, expiresAt: string }) => string;
    @Action private landingDomainsList!: (query: IPayloadQuery) => number;
    @Getter private getLandingDomains!: () => ILandingDomain[];
    // End Vuex Logic for Landing Domain

    private loading: boolean = true;

    private createLandingDomainForm: boolean = false;
    private detailLandingDomainForm: boolean = false;

    private landingDomains: ILandingDomain[] = [];

    private landingRegions: IMultiSelectItem[] = [];

    private selectedLandingDomain: ILandingDomain | null = null;

    // Begin Config for Pagination
    private totalLandingDomains: number | void | null = null;
    private currentPage: number = 1;
    private selectedLimit: string = '100';
    // End Config for Pagination


    private showModalDetail(landingDomain: ILandingDomain) {
        this.detailLandingDomainForm = !this.detailLandingDomainForm;
        this.selectedLandingDomain = landingDomain;
    }

    private hideModalDetail() {
        this.detailLandingDomainForm = false;
        this.selectedLandingDomain = null;
    }

    private showModalCreate() {
        this.createLandingDomainForm = !this.createLandingDomainForm
    }

    private hideModalCreate() {
        this.createLandingDomainForm = false;
    }

    private async deleteLandingDomain(id:number, time: string) {
        try {
            const expiresAt = time === 'expiresAt' ? time : null;

            await this.getLandingDomainsList();

            const notify = (status: string) => {


                if (status === 'deleted') {
                    this.$notify({
                        group: 'notice',
                        title: `Landing Domain`,
                        text: 'Deleted Successfully',
                        type: 'success'
                    });
                } else if (status === 'timer started') {
                    this.$notify({
                        group: 'notice',
                        title: `Landing Domain`,
                        text: 'Will be deleted in two days',
                        type: 'success'
                    });
                }

            };

            if (expiresAt) {
                const status = await this.landingDomainExpiresAt({
                    id,
                    expiresAt: format(addDays(today, 2), "yyyy-MM-dd'T'HH:mm:ss")
                });
                notify(status);
            } else {
                const status = await this.landingDomainRemove(id);
                notify(status);
            }
        } catch (error) {
            throw new Error(error);
        }
    }

    private get tableColumns(): ITableCol[] | undefined {
        return getTableColumns(this.landingDomains, true, ['id'], {name: 'delete'});
    };

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    // Begin Query Logic
    private get payloadQuery(): IPayloadQuery {
        return {
            ...getParamQuery(this.$route),
            metaData: true
        }
    }

    private queryValue() {
        if (this.payloadQuery.query && this.payloadQuery.query.length > 0) {
            this.readQueryValue();
        } else {
            this.writeQueryValue();
            this.readQueryValue();
        }
    }

    private readQueryValue() {
        const queryData = getQueryData(this.$route.query);

        queryData.map(({key, value}) => {
            switch (key) {
                case 'page': {
                    this.currentPage = value;
                    break;
                }
                case 'limit': {
                    this.selectedLimit = value;
                    break;
                }
                default:
                    break;
            }
        });
    }

    @Watch('selectedLimit')
    @Watch('currentPage')
    private writeQueryValue() {
        const queryData: any = {
            page: this.currentPage,
            limit: this.selectedLimit
        };

        this.$router.replace({
            name: this.$route.name || undefined,
            query: cleanData(queryData)
        });
    }

    // End Query Logic

    @Watch('selectedLimit')
    @Watch('currentPage')
    private async getLandingDomainsList() {
        try {
        this.loading = true;
        this.queryValue();

        this.totalLandingDomains = await this.landingDomainsList(this.payloadQuery);
        this.landingDomains = this.getLandingDomains();

        this.checkRegions();
        this.checkDateFields();

        this.loading = false;

        } catch(error) {
            throw new Error(error);
        }
    }

    // Begin Relation Region
    private async getRelation(){
        this.landingRegions = transformMultiSelect(this.getLandingRegions());

        if (isEmpty(this.landingRegions)) {
            await this.landingRegionsList({query :'?pagination=false'});
            this.landingRegions = transformMultiSelect(this.getLandingRegions());
        }
    }
    // End Relation Region


    private checkRegions():void {
        this.landingDomains.forEach((item: any) => {
            item.region = this.landingRegions.find((region:IMultiSelectItem) => region.value === item.region.id);
        })
    }

    // Begin Transform Data for Form Campaign
    private checkDateFields() {
        const dateFields: string[] = ['expiresAt'];
        transformDateFields(dateFields, this.landingDomains)
    }

    // End Transform Data for Form Campaign

    private async mounted() {
        try {
            await this.getRelation();
            await this.getLandingDomainsList();
        } catch(error) {
            throw new Error(error);
        }
    }
}
